module.exports = __webpack_public_path__ + "img/RU.5b8cc000.svg";